"use client";

import { useState } from "react";

type Props = {
  text: string;
  maxChars?: number;
  className?: string;
};

/**
 * Truncates long text with a Read more / Show less toggle.
 * Server renders the full text; client trims it on hydration.
 */
export default function ReadMore({ text, maxChars = 320, className }: Props) {
  const [expanded, setExpanded] = useState(false);
  if (text.length <= maxChars) {
    return <p className={className}>{text}</p>;
  }
  const visible = expanded ? text : text.slice(0, maxChars).replace(/\s+\S*$/, "") + "…";
  return (
    <div className={className}>
      <p className="whitespace-pre-line">{visible}</p>
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="mt-2 text-sm font-medium text-rose-600 hover:underline"
      >
        {expanded ? "Show less" : "Read more"}
      </button>
    </div>
  );
}
